<template>
  <div class="moduleStyle minHeight">
    <pageTitle title="采购分析" />
    <basicList
      :config="basicListconfig"
      @sortChange="sortChange"
      @search="searchEvent"
    >
      <template v-slot:additionalFeatures>
        <div class="procurementDataSummary procurementDataSummary2">
          <ul>
            <li>
              <div>
                <div class="summaryTitle">采购总量</div>
                <div class="today summaryLine">
                  <p>{{ summarizeData.total_buynum }}</p>
                </div>
              </div>
            </li>
            <li>
              <div>
                <div class="summaryTitle">采购总额</div>
                <div class="yesterday summaryLine">
                  <p>¥{{ summarizeData.total_buymoney | money }}</p>
                </div>
              </div>
            </li>
            <li>
              <div>
                <div class="summaryTitle">销售总量</div>
                <div class="summaryLine">
                  <p>{{ summarizeData.total_salenum }}</p>
                </div>
              </div>
            </li>
            <li>
              <div>
                <div class="summaryTitle">销售总额</div>
                <div class="summaryLine">
                  <p>¥{{ summarizeData.total_salesmoney | money }}</p>
                </div>
              </div>
            </li>
            <li>
              <div>
                <div class="summaryTitle">总毛利</div>
                <div class="summaryLine">
                  <p>¥{{ summarizeData.total_def_money | money }}</p>
                </div>
              </div>
            </li>
          </ul>
        </div>
        <div style="height: 20px"></div>
      </template>
    </basicList>
  </div>
</template>


<script>
// 列表默认参数
const defaultParameters = {
  page: 1,
  limit: 10,
};
import { getbuylist } from "@/api/report";
import {
  itemClassGetList,
  getshoplist,
  userGetlist,
} from "@/api/basicConfiguration";
import { getRoles } from "@/utils";
export default {
  name: "procurementAnalysis",
  data() {
    return {
      // 列表组件参数
      basicListconfig: {
        loading: false,
        operation: false,
        search: [
          {
            label: "所属门店",
            type: "select",
            options: [],
            key: "shop_id",
          },
          {
            label: "商品分类",
            type: "treeselect",
            options: [],
            multiple: true,
            key: "class_id",
          },
          {
            label: "品名/编码",
            type: "input",
            key: "keywords",
          },
          {
            label: "业务员",
            type: "select",
            options: [],
            key: "user_id",
          },
          {
            label: "日期",
            type: "quickDate",
            key: "time",
          },
        ],
        data: [],
        column: [
          {
            label: "品名",
            prop: "name",
            width: 250,
            fixed: "left",
          },
          {
            label: "编号",
            prop: "item_number",
            sortable: true,
            width: 140,
          },
          {
            label: "分类",
            prop: "class_name",
            width: 180,
          },
          {
            label: "门店",
            prop: "shop_name",
            width: 180,
          },
          {
            label: "采购量",
            prop: "buynum",
            sortable: true,
            width: 120,
          },
          {
            label: "采购成本价",
            prop: "purchaseAveragePrice",
            isMoney: true,
            sortable: true,
            width: 150,
          },
          {
            label: "采购总额",
            prop: "buytotal_money",
            sortable: true,
            isMoney: true,
            width: 150,
          },
          {
            label: "销售量",
            prop: "salenum",
            // isMoney: true,
            sortable: true,
            width: 150,
          },
          {
            label: "销售成本价",
            prop: "averageSellingPrice",
            sortable: true,
            isMoney: true,
            width: 150,
          },
          {
            label: "销售总额",
            prop: "total_money",
            sortable: true,
            isMoney: true,
            width: 150,
          },
          {
            label: "商品毛利",
            prop: "def_money",
            sortable: true,
            isMoney: true,
            width: 150,
          },
        ],
        isPage: true,
        total: 0,
        searchParameters: Object.assign({}, defaultParameters),
      },
      // 统计数据
      summarizeData: {
        total_buymoney: 0,
        total_buynum: 0,
        total_def_money: 0,
        total_salenum: 0,
        total_salesmoney: 0,
      },
    };
  },
  created() {
    // this.getData();
    this.obtainDataSource();
    this.searchEvent({
      shop_id: JSON.parse(getRoles()).shop_id,
    });
  },
  methods: {
    // 排序方法
    sortChange(data) {
      this.basicListconfig.searchParameters.page = 1;
      this.basicListconfig.searchParameters.order_column = data.prop;
      this.basicListconfig.searchParameters.order_up =
        data.order == "ascending" ? 1 : data.order == "descending" ? 0 : "";
      this.getData();
    },
    // 搜索方法
    searchEvent(data, page, pageSize) {
      if (page || pageSize) {
        if (page) this.basicListconfig.page = page;
        if (pageSize) this.basicListconfig.searchParameters.limit = pageSize;
        this.getData();
      } else if (data) {
        for (const key in data) {
          this.basicListconfig.searchParameters[key] = data[key];
          if (key == "time") {
            this.basicListconfig.searchParameters["begin_time"] = data[key]
              ? data[key][0]
              : null;
            this.basicListconfig.searchParameters["end_time"] = data[key]
              ? data[key][1]
              : null;
          }
        }
        this.basicListconfig.searchParameters.page = 1;
        this.getData();
      }
    },
    getData() {
      this.basicListconfig.loading = true;
      this.basicListconfig.search.map((item) => {
        if (item.key == "shop_id") {
          item.value = this.basicListconfig.searchParameters["shop_id"];
        }
        return item;
      });
      getbuylist(this.basicListconfig.searchParameters).then((res) => {
        if (res.code == 1) {
          this.basicListconfig.loading = false;
          this.basicListconfig.total = Number(res.count);
          this.basicListconfig.data = res.list.map((item) => {
            item.purchaseAveragePrice = (
              Number(item.buytotal_money) / Number(item.buynum)
            ).toFixed(2);
            item.averageSellingPrice = Number(item.salenum)
              ? (Number(item.total_money) / Number(item.salenum)).toFixed(2)
              : 0;
            return item;
          });
          for (const key in this.summarizeData) {
            this.summarizeData[key] = res[key];
          }
        } else {
          this.basicListconfig.loading = fals;
          this.$message.error(res.msg);
        }
      });
    },
    // 获取数据源
    obtainDataSource() {
      userGetlist({ limit: 10000, status: 0 }).then((res) => {
        if (res.code == 1) {
          this.basicListconfig.search.map((item) => {
            if (item.key == "user_id") {
              item.options = res.data.map((item) => {
                return {
                  label: item.name,
                  value: item.id,
                };
              });
            }
            return item;
          });
        } else {
          this.$message.error(res.data.msg || "获取供应商数据源失败！");
        }
      });
      itemClassGetList().then((res) => {
        if (res.code == 1) {
          this.basicListconfig.search.map((item) => {
            if (item.key == "class_id") {
              item.options = this.$findChildren(0, res.data);
            }
            return item;
          });
        } else {
          this.$message.error(res.msg);
        }
      });
      getshoplist({ status: 0, comp_id: JSON.parse(getRoles()).comp_id }).then(
        (res) => {
          if (res.code == 1) {
            this.basicListconfig.search.map((item) => {
              if (item.key == "shop_id") {
                item.options = res.data.map((item) => {
                  return {
                    label: item.name,
                    value: item.id,
                  };
                });
              }
              return item;
            });
          } else {
            this.$message.error(res.msg);
          }
        }
      );
    },
  },
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/views/procurementAnalysis/index.vue